import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Briefcase, Linkedin, MessagesSquare } from 'lucide-react';
import PropTypes from 'prop-types';
import { Popover } from '@getro/rombo';

import { Arrow } from '../arrow';

export const ConnectionBridge = ({ signal, sx, ...rest }) => {
  const hasExtraInfo = signal.extraInfo && signal.extraInfo.length > 0;

  const iconsTrigger = (
    <Flex justifyContent="center" sx={{ gap: '8px', cursor: hasExtraInfo ? 'pointer' : 'default' }}>
      {signal.linkedin && (
        <Box as={Linkedin} width="12px" height="12px" role="img" aria-label="LinkedIn" title="LinkedIn" />
      )}
      {signal.google && (
        <Box as={MessagesSquare} width="12px" height="12px" role="img" aria-label="Email" title="Email" />
      )}
      {signal.workOverlap && (
        <Box as={Briefcase} width="12px" height="12px" role="img" aria-label="Briefcase" title="Briefcase" />
      )}
    </Flex>
  );

  return (
    <Flex flexDirection="column" sx={{ gap: '16px', ...sx }} {...rest}>
      <Box px="8px">
        <Arrow color="purple.500" />
      </Box>
      {hasExtraInfo ? (
        <Popover
          position="top"
          content={
            <Box>
              <Text
                fontSize="12px"
                fontWeight="500"
                color="text.subtle"
                mb="8px"
                sx={{ letterSpacing: '1px', textTransform: 'uppercase' }}
              >
                Relationship Insights
              </Text>
              <Flex as="ul" flexDirection="column" sx={{ margin: 0, paddingLeft: '16px' }}>
                {signal.extraInfo.map((info) => (
                  <Text as="li" key={info} fontSize="14px">
                    {info}
                  </Text>
                ))}
              </Flex>
            </Box>
          }
          trigger={iconsTrigger}
          sx={{ width: '480px' }}
        />
      ) : (
        iconsTrigger
      )}
    </Flex>
  );
};

ConnectionBridge.propTypes = {
  signal: PropTypes.object.isRequired,
  sx: PropTypes.object,
};

ConnectionBridge.defaultProps = {
  sx: {},
};
